import { Modal, Form, Input, Button, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import {
  createLabDepartment,
  deleteLabDepartment,
  updateLabDepartment,
} from "store";
import useCheckPermission from "hooks/useCheckPermission";
import errorMessagesDescription from "components/mnl/global/errorMessagesDescription";
import { useCallback, useEffect, useState } from "react";
import notification from "components/mnl/global/openNotification";

const CreateUpdateLabDept = (props) => {
  const {
    handleCancel,
    openCreateUpdate,
    handleSubmit,
    isForUpdate,
    idForUpdate,
  } = props;

  const { handleVerifyPermission } = useCheckPermission();
  const accessRightsToDelete = handleVerifyPermission(
    "Administration:LabDepartment:Delete"
  );
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const LoadUpdateData = useCallback(() => {
    form.setFieldsValue({
      name: idForUpdate.name,
    });
  }, [form, idForUpdate]);

  useEffect(() => {
    if (isForUpdate) {
      LoadUpdateData();
    }
  }, [isForUpdate, LoadUpdateData]);

  const onFinish = (values) => {
    if (isForUpdate) {
      if (
        updateLabDepartment.pending().type ===
        "labDepartments/update-lab-department/pending"
      ) {
        setLoading(true);
      }
      dispatch(updateLabDepartment([idForUpdate.id, values])).then((val) => {
        if (val.type === "labDepartments/update-lab-department/fulfilled") {
          handleSubmit();
          setLoading(false);
          notification.success({
            message: "Updated Laboratory Department",
            description: `Successfully updated ${values.name}`,
          });
        }
      });
    } else {
      if (
        createLabDepartment.pending().type ===
        "labDepartments/create-lab-department/pending"
      ) {
        setLoading(true);
      }
      dispatch(createLabDepartment(values)).then((val) => {
        if (val.payload?.success) {
          handleSubmit();
          setLoading(false);
          notification.success({
            message: "Created Laboratory Department",
            description: `Successfully created ${values.name}`,
          });
        }
        if (!val.payload?.success) {
          setLoading(false);
          notification.error({
            message: "Failed to Create Laboratory Department",
            description: errorMessagesDescription(
              val.payload?.response?.data.errorMessages
            ),
          });
        }
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    errorInfo.errorFields.map((item) => {
      return notification.error({
        message: "Required Field",
        description: item?.errors[0].props.children,
      });
    });
  };

  const handleClickDelete = () => {
    //HANDLE LOADING
    if (
      deleteLabDepartment.pending().type ===
      "labDepartments/delete-lab-department/pending"
    ) {
      setLoading(true);
    }
    dispatch(deleteLabDepartment(idForUpdate.id)).then((val) => {
      if (val.payload?.success) {
        handleSubmit();
        setLoading(false);
        notification.success({
          message: "Deleted Laboratory Department",
          description: `Successfully deleted ${idForUpdate.name}`,
        });
      }
      if (!val.payload?.success) {
        setLoading(false);
        notification.error({
          message: "Failed to Delete Laboratory Department",
          description: errorMessagesDescription(
            val.payload?.response?.data.errorMessages
          ),
        });
      }
    });
  };

  return (
    <Modal
      open={openCreateUpdate}
      title={
        isForUpdate
          ? "Update Laboratory Department"
          : "Create Laboratory Department"
      }
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        name="labDepartment"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        {/* Type Name */}
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: <i>{"Please input Name."}</i>,
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            style={{ margin: 2 }}
            className="submitBtn"
          >
            Submit
          </Button>
          {accessRightsToDelete && isForUpdate ? (
            <Popconfirm
              title="Delete the department"
              description="Are you sure to delete?"
              onConfirm={handleClickDelete}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ loading: loading, className: "submitBtn" }}
            >
              <Button loading={loading} type="primary" danger>
                Delete
              </Button>
            </Popconfirm>
          ) : null}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateUpdateLabDept;
